module.exports = __webpack_public_path__ + "static/1-19a4c048cc206d3d7f5afdfcad874453.png";